import { Button, Image, Modal } from 'react-bootstrap';

// Styles
import { StyledModalTitle } from './styles'

// Assets
import EInkwithAIRIDNickname from '../../../assets/images/EInkwithAIRIDNickname.png';


interface EInkModalProps {
    showImg: boolean;
    onBtnClick: (value: boolean) => void;
}

export function EInkModal({showImg, onBtnClick}: EInkModalProps) {
    return (
        <Modal
            show={showImg}
            onHide={() => onBtnClick(false)}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header closeButton>
                <StyledModalTitle>Robot AIR ID and Name on the e-ink display</StyledModalTitle>
            </Modal.Header>
            <Modal.Body>
                <Image
                src={EInkwithAIRIDNickname}
                className="img-fluid"
                alt='Robot AIR ID'
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => onBtnClick(false)}>
                Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}